/**
 * Campaign workspace / thread membership denial — FE mirror of boxofix
 * `constants/campaignAccessDenied.js`.
 *
 * Status follows {@link ./httpStatus.ts} `HTTP_FORBIDDEN_STATUS`.
 * Do not treat plain 401 as workspace-forbidden (session refresh / auth modal).
 */
import { HTTP_FORBIDDEN_STATUS } from './httpStatus';

export const CAMPAIGN_ACCESS_DENIED_HTTP_STATUS = HTTP_FORBIDDEN_STATUS;

export const CAMPAIGN_ACCESS_DENIED_CODES = {
    WORKSPACE: 'CAMPAIGN_WORKSPACE_FORBIDDEN',
    THREAD: 'CAMPAIGN_THREAD_FORBIDDEN',
} as const;

export type CampaignAccessDeniedCode = (typeof CAMPAIGN_ACCESS_DENIED_CODES)[keyof typeof CAMPAIGN_ACCESS_DENIED_CODES];
